import React, { useRef } from "react";
import fieldPropTypes from "../field-prop-types";
import renderFields from "../../screens/render-fields";

const ModernizedAccordion = ({
  field,
  appData,
  components,
  components: { ModernizedAccordion: AccordionComponent },
  screen
}) => {
  const fieldRef = useRef();
  const { fieldLayouts } = field;
  const containerFields = fieldLayouts[0]?.containerFields;

  if (!containerFields?.length) {
    return null;
  }

  const nestedContent = renderFields(
    containerFields,
    appData,
    components,
    screen
  );

  return (
    <AccordionComponent field={field} fieldRef={fieldRef}>
      {nestedContent}
    </AccordionComponent>
  );
};

ModernizedAccordion.propTypes = fieldPropTypes;

export default ModernizedAccordion;
